import type { WebsiteImage, WebsiteImageAttribution } from './types'

export function publicImageAttribution(
  image: WebsiteImage | null | undefined,
): WebsiteImageAttribution | null {
  if (image?.source !== 'unsplash') return null

  return image.attribution ?? null
}
